import React from "react"
import styled from "styled-components"
// Assets
import logo from "../../assets/img/logo.png"
import StrategyIcon from "../../assets/svg/Services/strategy.svg"
import OperationsIcon from "../../assets/svg/Services/operations.svg"
import TechnologyIcon from "../../assets/svg/Services/technology.svg"
import HumanCapitalIcon from "../../assets/svg/Services/human-capital.svg"
import FinancialIcon from "../../assets/svg/Services/financial.svg"

export default function ServiceBox({ icon, title, subtitle }) {
  let getIcon

  switch (icon) {
    case "strategy":
      getIcon = (
        <img src={StrategyIcon} height={100} width={100} alt="strategy" />
      )
      break
    case "operations":
      getIcon = (
        <img src={OperationsIcon} height={100} width={100} alt="operations" />
      )
      break
    case "technology":
      getIcon = (
        <img src={TechnologyIcon} height={100} width={100} alt="technology" />
      )
      break
    case "human-capital":
      getIcon = (
        <img
          src={HumanCapitalIcon}
          height={100}
          width={100}
          alt="human-capital"
        />
      )
      break
    case "financial":
      getIcon = (
        <img src={FinancialIcon} height={100} width={100} alt="financial" />
      )
      break
    default:
      getIcon = (
        <img
          src={logo}
          className="logo"
          alt="Boditel logo"
          height={48}
          width={192}
        />
      )
      break
  }

  return (
    <Wrapper className="flex flexColumn">
      <IconStyle>{getIcon}</IconStyle>
      <TitleStyle className="font20 extraBold">{title}</TitleStyle>
      <SubtitleStyle className="font13">{subtitle}</SubtitleStyle>
    </Wrapper>
  )
}

const Wrapper = styled.div`
  width: 100%;
`
const IconStyle = styled.div`
  @media (max-width: 860px) {
    margin: 0 auto;
  }
`
const TitleStyle = styled.h2`
  width: 100%;
  max-width: 300px;
  margin: 0 auto;
  padding: 40px 0;
  @media (max-width: 860px) {
    padding: 20px 0;
  }
`
const SubtitleStyle = styled.p`
  width: 100%;
  max-width: 300px;
  margin: 0 auto;
`
